/**
 * Usuarios de administración — escrituras.
 *
 * Solo el listado pasa por el dataProvider (resource `platform-users`); el
 * resto son rutas dedicadas de `/platform-user`, igual que en
 * user-management. Todas exigen rol SuperUser en el backend.
 */

import { httpClient } from '@/utils/httpClient';
import type { NotifyEnvelope } from '@/types/api';
import type {
  PlatformUserCreatePayload,
  PlatformUserRecord,
  PlatformUserUpdatePayload,
} from '../types/platformUser';

export const getPlatformUser = async (
  keycloakId: string
): Promise<PlatformUserRecord> => {
  const { data } = await httpClient.get<NotifyEnvelope<PlatformUserRecord>>(
    `/platform-user/${encodeURIComponent(keycloakId)}`
  );
  return data.Response;
};

export const createPlatformUser = async (
  payload: PlatformUserCreatePayload
): Promise<PlatformUserRecord> => {
  const { data } = await httpClient.post<NotifyEnvelope<PlatformUserRecord>>(
    '/platform-user',
    payload
  );
  return data.Response;
};

export const updatePlatformUser = async (
  keycloakId: string,
  payload: PlatformUserUpdatePayload
): Promise<void> => {
  await httpClient.put(
    `/platform-user/${encodeURIComponent(keycloakId)}`,
    payload
  );
};

/** Bloquear / desbloquear: conserva el rol, impide entrar. */
export const setPlatformUserEnabled = async (
  keycloakId: string,
  enabled: boolean
): Promise<void> => {
  await httpClient.put(
    `/platform-user/${encodeURIComponent(keycloakId)}/enabled`,
    { enabled }
  );
};

/** Contraseña temporal: Keycloak le pedirá cambiarla al entrar. */
export const setPlatformUserPassword = async (
  keycloakId: string,
  password: string
): Promise<void> => {
  await httpClient.put(
    `/platform-user/${encodeURIComponent(keycloakId)}/password`,
    { password }
  );
};

/**
 * Retira el acceso al backoffice. NO borra la identidad: el realm es
 * compartido con locks, desk, pay y el resto de productos Roommatik.
 */
export const revokePlatformUserAccess = async (
  keycloakId: string
): Promise<void> => {
  await httpClient.delete(
    `/platform-user/${encodeURIComponent(keycloakId)}/access`
  );
};
